import { TextField, MenuItem, TextFieldProps } from "@mui/material";
import { Controller, Control, FieldPath, FieldValues } from "react-hook-form";

interface Option {
  value: string | number;
  label: string;
}

interface FormSelectFieldProps<T extends FieldValues>
  extends Omit<TextFieldProps, "name" | "value" | "onChange" | "select"> {
  name: FieldPath<T>;
  control: Control<T>;
  label: string;
  options: Option[];
  placeholder?: string;
  required?: boolean;
}

export const FormSelectField = <T extends FieldValues>({
  name,
  control,
  label,
  options,
  placeholder,
  required = false,
  ...textFieldProps
}: FormSelectFieldProps<T>) => {
  return (
    <Controller
      name={name}
      control={control}
      render={({ field, fieldState: { error } }) => (
        <TextField
          {...field}
          {...textFieldProps}
          select
          label={label}
          error={!!error}
          helperText={error?.message || textFieldProps.helperText}
          required={required}
          variant={textFieldProps.variant || "standard"}
          placeholder={placeholder}
        >
          {placeholder && (
            <MenuItem value="" disabled>
              {placeholder}
            </MenuItem>
          )}
          {options.map((option) => (
            <MenuItem key={option.value} value={option.value}>
              {option.label}
            </MenuItem>
          ))}
        </TextField>
      )}
    />
  );
};
